import _ from '@lodash';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useWorkflow } from '../../WorkflowProvider';
import { TransInputKeysField, TransRadioInputFieldsPropertiesArray, TransNameField, TransOutputKeyField, TransValidationIOKey, TransValidationName, TransInputSwitchValueType } from '../TransformationProperties';
import TransformationPropertiesDialog from '../TransformationPropertiesDialog';
import { converter } from './SwitchTransformation';

function SwitchProperties(props) {
	const { data, showPropertiesDialog, transformationNameAvailable } = useWorkflow();
	const { t } = useTranslation(['transformer', 'validation']);
	const item = data.transform.find(d => d.key === showPropertiesDialog.key);

	const schema = yup.object().shape({
		name: TransValidationName(transformationNameAvailable, item.key),
		input_fields: TransValidationIOKey(),
		output_fields: TransValidationIOKey()
	});

	return (
		<TransformationPropertiesDialog schema={schema} titleKey="switchProperties" converter={converter}>
			<TransNameField />
			<TransInputKeysField />
			<TransRadioInputFieldsPropertiesArray />
			<TransInputSwitchValueType />
			<TransOutputKeyField />
		</TransformationPropertiesDialog>
	);
}
export default SwitchProperties;
